import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  carpetas: string[] = ['salon', 'peinados', 'productos'];

  selectedFolder = this.carpetas[1];

  constructor() { }

  ngOnInit(): void {
  }

}
